import React from "react";
import styled from "styled-components";
import CloudBreadcrumbGroup, {
  BreadcrumbGroupProps,
} from "@cloudscape-design/components/breadcrumb-group";
import { NavigateFunction, useNavigate } from "react-router-dom";

//Todo
//@tanmayee need to change implementation a bit and add unit tests
//After that remove from test coverage exclude list in vite.config.ts
const BreadCrumbsGroup = styled(CloudBreadcrumbGroup)`
  a:link {
    text-decoration-line: none !important;
  }
`;

//todo added this as a reference need to work on this while working on Page related SIM's so not adding any unit tests for now
export const useBreadcrumbs = ({
  onFollow,
  ...rest
}: BreadcrumbGroupProps): JSX.Element => {
  const navigate = useNavigate();
  const onFollowHandler = onFollow ?? reactRouterOnFollow(navigate);
  return <BreadCrumbsGroup {...rest} onFollow={onFollowHandler} />;
};

const reactRouterOnFollow =
  (navigate: NavigateFunction) =>
  (event: Parameters<Required<BreadcrumbGroupProps>["onFollow"]>[0]) => {
    if (event.detail.external) {
      return;
    }
    event.preventDefault();
    navigate(event.detail.href);
  };
